import { extraPrices } from '../constants/common';

const getDomainPrices = ({ priceData, currency, extraPrice, isSpecialOfferAvailable }) => {
  if (!isSpecialOfferAvailable || !priceData['P1Y'].extra_prices) {
    return {
      price: priceData['P1Y'].prices[currency],
    };
  }

  if (extraPrice === extraPrices.FREE_COM_DOMAIN) {
    return {
      price: priceData['P1Y'].extra_prices.free_com_domain[currency],
      oldPrice: priceData['P1Y'].prices[currency],
    };
  }

  if (extraPrice === extraPrices.ANNUAL_TRIAL_PACKAGE) {
    return {
      price: priceData['P1Y'].extra_prices.annual_trial_package[currency],
      oldPrice: priceData['P1Y'].prices[currency],
    };
  }

  if (extraPrice === extraPrices.NO_DISCOUNTS) {
    return {
      price: priceData['P1Y'].prices[currency],
      oldPrice: priceData['P1Y'].extra_prices.no_discounts[currency],
    };
  }

  return {
    price: priceData['P1Y'].prices[currency],
  };
};

export default getDomainPrices;
